/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Commission_PctInputs */

const es_ab_commission_pct = /** @type {(inputs: Ab_Commission_PctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%`)
};

const gl_ab_commission_pct = /** @type {(inputs: Ab_Commission_PctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%`)
};

const en_ab_commission_pct = /** @type {(inputs: Ab_Commission_PctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15%`)
};

/**
* | output |
* | --- |
* | "15%" |
*
* @param {Ab_Commission_PctInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_commission_pct = /** @type {((inputs?: Ab_Commission_PctInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Commission_PctInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_commission_pct(inputs)
	if (locale === "en") return en_ab_commission_pct(inputs)
	return es_ab_commission_pct(inputs)
});